﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import React, {useRef} from "react";
import {useControlId} from "../helpers/useControlId";
import {LabeledControlAriaProps} from "./LabeledControl";

export interface LabeledControlData {
	componentId: string,
	ariaRef: React.RefObject<LabeledControlAriaProps | undefined>;
}

export function useLabeledControl(id?: string, hint?: string, error?: string): LabeledControlData {
	const componentId = useControlId(id);
	const ariaRef = useRef<LabeledControlAriaProps | undefined>(undefined);
	// Computed here, during the OWNER's render — before the input element is built — so
	// aria-invalid/aria-describedby are correct on the very render that first shows an error.
	// (LabeledControl also writes this while rendering as a child, which is one render too
	// late for the input; its write stays as a fallback for callers not passing hint/error.)
	const hasError = !isNullOrEmpty(error);
	const hasHint = hint != null;
	ariaRef.current = {
		describedBy: ((hasHint ? componentId + "-hint" : "") + (hasError ? " " + componentId + "-error" : "")).trimStart(),
		invalid: hasError
	};
	return {componentId, ariaRef};
}
